import React, { useState } from 'react';
import Modal from '../../Shared/Modal';

function Servings({ servings, onChange, readOnly }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [tempValue, setTempValue] = useState(servings || '');
  const servingsOptions = Array.from({ length: 20 }, (_, i) => i + 1);

  return (
    <div className="h-full w-full flex flex-col items-center justify-center px-[3%] text-center text-[#5a3e36]">
      <label
        htmlFor="servingsSelect"
        className="text-[clamp(0.65rem,1.2vw,0.875rem)] font-semibold leading-tight mb-[1%]"
      >
        Servings:
      </label>

      {readOnly ? (
        <div className="text-[clamp(0.65rem,1.2vw,0.875rem)] font-normal leading-tight truncate max-w-full">
          {servings?.trim() || <span className="text-transparent select-none">.</span>}
        </div>
      ) : (
        <div
          className="
            w-full max-w-[3rem] sm:max-w-[4rem]
            h-[clamp(1.8rem,2.2rem,2rem)]
            text-[clamp(0.65rem,1.2vw,0.875rem)]
            border border-[#e0c3a5] rounded
            bg-white flex items-center justify-center
            cursor-pointer select-none
          "
          onClick={() => {
            setTempValue(servings || '');
            setIsModalOpen(true);
          }}
        >
          {servings || <span className="text-transparent select-none">.</span>}
        </div>
      )}
      <Modal open={isModalOpen} onClose={() => setIsModalOpen(false)} title="Set Servings">
        <div className="flex flex-col gap-3">
          <input
            type="number"
            value={tempValue}
            onChange={(e) => setTempValue(e.target.value)}
            min={1}
            max={20}
            autoFocus
            onFocus={(e) => e.target.select()}
            className="
              w-full text-center text-lg 
              border border-dominant-purple rounded 
              px-3 py-2 
              focus:outline-none focus:ring-2 focus:ring-rich-gold
              placeholder:text-slate-400
            "
            placeholder="Enter 1–20"
          />
          <button
            className="bg-rich-gold text-white px-6 py-2.5 rounded-xl text-base font-marketing hover:bg-dominant-purple hover:text-white transition duration-250 ease-out-quad"
            onClick={() => {
              if (/^(?:[1-9]|1[0-9]|20)$/.test(tempValue)) {
                onChange(tempValue);
                setIsModalOpen(false);
              } else {
                alert("Please enter a number from 1 to 20.");
              }
            }}
          >
            Confirm
          </button>
        </div>
      </Modal>
    </div>
  );
}

export default Servings;